import { useUploadAttachments } from '@/features/attachment/_hooks/attachment';
import { useMessage } from '@/providers';
import { type FC, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateReply } from '@/features/comment/hooks/reply';
import { CommentReplyForm } from '../../reply';

export const CommentDetailsReplyForm: FC<{
  commentId: string;
}> = ({ commentId }) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const [randomKey, updateRandomKey] = useReducer(
    (state) => (state ? 0 : 1),
    0,
  );

  const { mutateAsync: createReply } = useCreateReply();
  const { uploadAttachments } = useUploadAttachments();

  return (
    <CommentReplyForm
      type="new"
      key={randomKey}
      onSubmit={async ({ content, fileEntries }) => {
        const attachmentIds: string[] =
          fileEntries?.flatMap((entry) =>
            entry.attachment ? [entry.attachment.id] : [],
          ) ?? [];

        const files = fileEntries?.flatMap((entry) =>
          entry.file ? [entry.file] : [],
        );

        if (files?.length) {
          const uploadedAttachmentIds = await uploadAttachments(files);
          if (uploadedAttachmentIds?.length) {
            attachmentIds.push(...uploadedAttachmentIds);
          }
        }

        try {
          await createReply({
            content,
            commentId,
            attachmentIds,
          });
          updateRandomKey();
          await openMessage('success', t('add-completed'));
        } catch {
          await openMessage('error', t('message-create-failed'));
        }
      }}
    />
  );
};
